const FETCH_TT11_1_REPORT_REQUEST = "FETCH_TT11_1_REPORT_REQUEST";
const FETCH_TT11_1_REPORT_SUCCESS = "FETCH_TT11_1_REPORT_SUCCESS";
const FETCH_TT11_1_REPORT_FAILURE = "FETCH_TT11_1_REPORT_FAILURE";

export default {
  FETCH_TT11_1_REPORT_REQUEST,
  FETCH_TT11_1_REPORT_SUCCESS,
  FETCH_TT11_1_REPORT_FAILURE,
};
